import { CTA } from "@volkswagen-onehub/components-core";
import { Reload } from "@volkswagen-onehub/icons-core";
import React, { SyntheticEvent } from "react";
import { useNavigate } from "react-router-dom";
import { getTranslations } from "../translations";
import { useFiltering } from "../utils/use-filtering";

export const NewSearchButton = () => {
  const { labels } = getTranslations();
  const navigate = useNavigate();
  const { startNewSearch } = useFiltering();
  const handleClick = (e: SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    startNewSearch();
    navigate({ pathname: '/' });
  };

  return (
    <CTA
      tag="a"
      href="/"
      emphasis="tertiary"
      onClick={handleClick}
      icon={<Reload variant="small" />}
      iconPosition="end"
    >
      {labels.new_search}
    </CTA>
  );
};
